angular.module('rjmNg.services').factory('clientService', [
  "$q"
  "Client"
  ($q, Client) ->
    return (clientId) ->
      clientService = {}

      clientService.fetch = () ->
        deferred = $q.defer()

        Client.get(
          clientId: clientId
        , (result) ->
          deferred.resolve(result)
        )

        return deferred.promise

      clientService.update = (client) ->
        # use deep copy here so we don't overwrite the value of company name
        # as the user types
        copy = $.extend(true, {}, client)

        copy.$save(
          clientId: client.id
        )

      return clientService
  ]
)
